var mixpanel = require("mixpanel-browser");

mixpanel.init("fb9b9c51c10796a94a8f6c90c5f18627");
import axios from "axios";

export const track_user = (controller, event, props = {}) => {
  try {
    if (controller.$store.getters.isAuthenticated) {
      let profile = controller.$store.getters.getProfile;

      if (profile != null) {
        if (profile.user_profile) {
          profile = profile.user_profile;
        }

        props["$first_name"] = profile.user.first_name;
        props["$last_name"] = profile.user.last_name;
        props["$phone"] = profile.phone_number;
        props["$distinct_id"] = profile.user.id;
        props["id"] = profile.user.id;
        props["$email"] = profile.user.email;
      }
    }
  } catch (err) {
    // console.log(err)
  }

  axios
    .get(`https://ipinfo.io/?token=aebb396a784844`)
    .then((res) => {
      (props["user_info"] = res.data.ip),
        // console.log(props)
      mixpanel.track(event, props);
    })
    .catch((err) => {
      props["user_info"] = "Anonymous User";
      mixpanel.track(event, props);
    });
};
